import { Item } from "@coworker/apprestructured/src/shared/types/item";
import { ProductSearchPagePresentation } from "./ProductSearchPagePresentation";
import React from "react";
import { SearchItemCardRenderType } from "@coworker/apprestructured/src/scan-and-search/types/SearchItemCardRenderType";

interface ProductSearchComponentProps {
  searchQuery: string;
  setSearchQuery: React.Dispatch<React.SetStateAction<string>>;
  handleItemCardClick: (item: Item) => void;
  itemCardRenderType: SearchItemCardRenderType;
  shouldHideSPRItems: boolean;
  shouldHideLocalCombinationItems: boolean;
  shouldShowCloseButton?: boolean;
  shouldHideHistory?: boolean;
  handleClose?: () => void;
}

export const ProductSearchComponent = ({
  searchQuery,
  setSearchQuery,
  handleItemCardClick,
  handleClose = () => {},
  itemCardRenderType,
  shouldShowCloseButton = false,
  shouldHideSPRItems,
  shouldHideLocalCombinationItems,
  shouldHideHistory = false,
}: ProductSearchComponentProps) => {
  return (
    <ProductSearchPagePresentation
      shouldHideHistory={shouldHideHistory}
      itemCardRenderType={itemCardRenderType}
      searchQuery={searchQuery || ""}
      setSearchQuery={setSearchQuery || (() => {})}
      handleItemCardClick={handleItemCardClick}
      handleClose={handleClose}
      shouldShowCloseButton={shouldShowCloseButton}
      shouldHideSPRItems={shouldHideSPRItems}
      shouldHideLocalCombinationItems={shouldHideLocalCombinationItems}
    />
  );
};
